import domReady from '@wordpress/dom-ready';
import { Navigation } from './components/navigation';
import { Disclosure } from './components/disclosure';
import { QuickQuote } from './components/quick-quote';
import { ArticleToc } from './components/article-toc';
import { SmoothScroll } from './components/smooth-scroll';

domReady( () => {
	SmoothScroll();
	Navigation();
	Disclosure();
	QuickQuote();
	ArticleToc();
} );
